export default __webpack_public_path__ + "static/media/stpdetailsicon.b1a5351b.svg";